export default class {
	constructor($http) {
		this.$http = $http;
	}

	getModules() {
		return this.$http.get(`lbadmin/modules`);
	}

	getObjectHasPermissions(objectUid) {
		return this.$http.get(`lbadmin/object-has-permissions/${objectUid}`);
	}

	getObjectSetPermissions(objectUid) {
		return this.$http.get(`lbadmin/object-set-permissions/${objectUid}`);
	}

	getGroupRoles() {
		return this.$http.get(`lbadmin/group-roles`);
	}

	getProfiles() {
		return this.$http.get(`lbadmin/profile-list`);
	}

}
